<a [routerLink]="['/app', 'meetings', call.id, 'setup']" [queryParams]="{ isSearchOpen: null }" queryParamsHandling="merge" (click)="onCardClick()">
  <div class="panel" [class.calendar-sync-lost]="hasLostCalendarSync">
    <div class="details">
      <div class="header">
        <div class="title-row">
          <div class="title">{{ call.name }}</div>
          @if (hasLostCalendarSync) {
            <mat-icon class="calendar-sync-lost-icon" [matTooltip]="'CALLS.UPCOMING_MEETING.CALENDAR_SYNC_LOST_TOOLTIP' | translate">warning</mat-icon>
          }
        </div>
        <div class="counterparty-names" [matTooltip]="formattedCounterpartyNames">{{ formattedCounterpartyNames }}</div>
      </div>
      <div class="footer">
        <div class="date-container">
          <div class="day-container">
            <div class="day">{{ call.date | date: 'd' }}</div>
          </div>
          <div class="month-year-container">
            <div class="month">{{ call.date | date: 'MMMM' }}</div>
            <div class="year">{{ call.date | date: 'y' }}</div>
          </div>
        </div>
        <div class="other-details-container">
          <span class="time">
            <mat-icon class="icon" fontIcon="access_time"></mat-icon>
            {{ call.date | date: 'HH:mm' }}
          </span>
          @if (isMultipleAgendaType) {
            <mat-icon class="stack-icon" [matTooltip]="'COMMON.AGENDA_TYPE_MULTIPLE_TOOLTIP' | translate">layers</mat-icon>
          }
          @if (call.accessLevel === 'VIEWER') {
            <mat-icon class="access-level-icon" [matTooltip]="'CALLS.SHARE_DIALOG.LEVELS.VIEWER' | translate">visibility</mat-icon>
          } @else if (call.accessLevel === 'COMMENTER') {
            <mat-icon class="access-level-icon" [matTooltip]="'CALLS.SHARE_DIALOG.LEVELS.COMMENTER' | translate">comment</mat-icon>
          } @else if (call.accessLevel === 'EDITOR') {
            <mat-icon class="access-level-icon" [matTooltip]="'CALLS.SHARE_DIALOG.LEVELS.EDITOR' | translate">edit_note</mat-icon>
          }
        </div>
      </div>
    </div>
    <div class="buttons">
      <div class="top-buttons">
        @if (botWillJoinAgainstUserSelection) {
          <button
            mat-icon-button
            class="force-disable-button"
            (click)="$event.stopPropagation(); $event.preventDefault(); forceDisableJoining(call)"
            [matTooltip]="'CALLS.FORCE_DISABLE_JOIN' | translate"
          >
            <mat-icon fontSet="material-symbols-outlined">visibility_off</mat-icon>
          </button>
        }
        @if (displayDeleteButton) {
          <div class="menu">
            <button mat-icon-button (click)="onMenuClick($event)" [matMenuTriggerFor]="menu">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item translate="COMMON.DELETE" (click)="delete(call)"></button>
            </mat-menu>
          </div>
        }
      </div>
      <div class="bottom-buttons">
        @if (allowJoiningNow) {
          <button
            mat-icon-button
            (click)="$event.stopPropagation(); $event.preventDefault(); joinNow()"
            [matTooltip]="'CALLS.JOIN_NOW.BUTTON_TOOLTIP' | translate"
          >
            <mat-icon fontSet="material-symbols-outlined" style="transform: rotate(180deg)">start</mat-icon>
          </button>
        }
        <mat-slide-toggle
          [class.soft-toggle]="botWillJoinAgainstUserSelection"
          (click)="$event.stopPropagation(); $event.preventDefault()"
          [checked]="call.isSetToJoin"
          (change)="toggleExclude(call.id, $event.checked)"
          labelPosition="after"
          [matTooltip]="excludeToggleTooltip"
        >
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</a>
